import * as environments from '../environment';

const PluginEnvironment = {
  install(Vue) {
    Vue.prototype.$environments = {
      ...environments,
    };
  },
};

export default PluginEnvironment;
